export default "__VITE_ASSET__DiiIfPqy__"